module.exports = __webpack_public_path__ + "static/media/Cats Eyes 09_ENGELSKA-mixdown.6bb166d7.mp3";